import { createQueryClient } from '@/shared/api';
import { notifyError } from '@/shared/ui';

/** Единый QueryClient приложения: ошибки мутаций и фоновых обновлений — тостом (sonner). */
export const queryClient = createQueryClient({ notify: notifyError });
